"use client";
import { jsx as a, jsxs as M } from "react/jsx-runtime";
import N from "../../common/components/input-meta/InputMeta.js";
import V from "../../common/components/label/Label.js";
import { COLOR_SEVERITY as W } from "../../common/constants/colorSeverity.js";
import { isSSR as q } from "../../common/helpers/isSSR.js";
import { InputFieldWrapper as G } from "../../common/styles/components/InputFieldWrapper.js";
import u from "../icon/Icon.js";
import { css as H } from "@emotion/react";
import R from "@emotion/styled";
import { useFeId as K } from "../../hooks/useFeId.js";
import { COLORS as e } from "../../tokens/colors/Colors.js";
import { ConfigProvider as Y, DatePicker as b } from "antd";
import C from "dayjs";
import { useState as _, useEffect as z } from "react";
const { RangePicker: J } = b, x = ({
  "aria-errormessage": r,
  disabled: t = !1,
  feHideIcon: S = !1,
  feHideLabel: L,
  feHint: f,
  feLabel: j,
  feRange: g,
  feRequiredText: F,
  feSeverity: c,
  feSize: l = "md",
  id: p = K(),
  locale: T,
  onChange: m,
  required: $,
  value: i
}) => {
  const B = I(i), A = !I(i), h = f && c === "error" ? `${p}-hint` : void 0, D = {
    "aria-errormessage": h ?? r,
    disabled: t,
    suffixIcon: S ? null : /* @__PURE__ */ a(u, { feIcon: "calendar" }),
    size: Q[l],
    locale: T,
    id: p,
    allowClear: { clearIcon: /* @__PURE__ */ a(u, { feIcon: "close", onClick: () => E() }) }
  }, [k, d] = _(null);
  z(() => {
    if (q())
      return;
    if (B && !i.every((n) => typeof n > "u")) {
      const n = U(i);
      d(n);
    }
    if (A && i) {
      const n = C(i);
      d(n);
    }
  }, [i]);
  const E = () => {
    g ? y(null, m) : P(null, m);
  }, y = (o, n) => {
    if (d(o), !o)
      return;
    const s = X(o);
    n(s);
  }, P = (o, n) => {
    const s = o;
    if (d(s), !s)
      return;
    const w = s.toDate();
    n(w);
  };
  return /* @__PURE__ */ a(
    Y,
    {
      theme: {
        token: {
          colorPrimary: e.brand,
          borderRadius: 2,
          colorBorder: e.gray500,
          colorTextPlaceholder: e.gray600,
          colorText: e.black,
          colorLink: e.brand,
          fontFamily: "SKF Sans, sans-serif",
          controlHeightLG: 43.875,
          colorIcon: e.black,
          colorLinkHover: e.primary800
        },
        components: {
          DatePicker: {
            activeShadow: "none",
            cellActiveWithRangeBg: e.primary300,
            cellHoverBg: e.primary300,
            hoverBorderColor: "none"
          }
        }
      },
      children: /* @__PURE__ */ M(G, { "data-comp": "date-picker", feSize: l, children: [
        /* @__PURE__ */ a(
          V,
          {
            feDisabled: t,
            feHideLabel: L,
            feRequired: $,
            feRequiredText: F,
            feSize: l,
            htmlFor: p,
            children: j
          }
        ),
        g ? /* @__PURE__ */ a(
          Z,
          {
            ...D,
            value: k,
            separator: /* @__PURE__ */ a(u, { feIcon: "arrowRight", feSize: "md" }),
            onChange: (o) => y(o, m),
            feSeverity: c
          }
        ) : /* @__PURE__ */ a(
          v,
          {
            ...D,
            value: k,
            onChange: (o) => P(o, m),
            feSeverity: c
          }
        ),
        f && /* @__PURE__ */ a(N, { feSeverity: c, feSize: l, id: h, children: f })
      ] })
    }
  );
};
x.displayName = "DatePicker";
const ur = x, Q = {
  sm: "middle",
  md: "large"
};
function U(r) {
  return r.map((t) => {
    if (t)
      return C(t);
  });
}
function X(r) {
  return r.map((t) => t == null ? void 0 : t.toDate());
}
function I(r) {
  return r ? r && Array.isArray(r) : !1;
}
const O = ({ feSeverity: r }) => H`
	border-color: ${r && W[r].base};

	&:has(input:focus-visible) {
		outline: ${e.brand} auto 1px;
	}
`, Z = R(J)(
  ({ feSeverity: r }) => O({ feSeverity: r })
), v = R(b)(
  ({ feSeverity: r }) => O({ feSeverity: r })
);
export {
  ur as default
};
